<template>
  <div>
    <h1>{{ pageTitle }}</h1>
    <div class="columns">

      <div class="column">
        <h4>Architectural Sample Binder</h4>
        <img src="/print/tekstur-binder.jpg">
        <p>Details:</p>
        <ul class="content">
          <li>1" Three Ring Binder with 8.5" x 11" Inserts</li>
          <li>4/4 Color on #100 Gloss Cover</li>
        </ul>
        <p>
          <a href="https://tekstur.com/print/tekstur-binder-design-indd.zip" class="button" download>Download Binder Print Assets</a> &nbsp;
          <a href="https://tekstur.com/print/tekstur-binder-inserts-pdf.pdf" class="button" download>Download Inserts Print Assets</a>
        </p>
      </div>

      <div class="column">
        <h4>Architectural Sample Box</h4>
        <img src="/print/tekstur-sample-box.jpg">
        <p>Details:</p>
        <ul class="content">
          <li>3" Cube Tuck Fold Box</li>
          <li>Interior Dimensions are 3" x 3" x 3"</li>
        </ul>
        <p>
          <a href="https://tekstur.com/print/tesktur-sample-box-ai.zip" class="button" download>Download Print Assets</a>
        </p>
      </div>

    </div>
    <div class="columns">

      <div class="column">
        <h4>Trifold 8.5" x 11" Brochure</h4>
        <img src="/print/tekstur-trifold-mockup.png">
        <p>Details:</p>
        <ul class="content">
          <li>8.5" x 11" Folded - 24.75" x 11" Flat</li>
          <li>4/4 Color on #100 Gloss Cover</li>
        </ul>
        <p>
          <a href="https://tekstur.com/print/tekstur-trifold-design-pdf.pdf" class="button" download>Download Print Assets</a>
        </p>
      </div>

      <div class="column">
        <h4>8.5" x 5.5" Postcard</h4>
        <img src="/print/tekstur-postcard-mockup.png">
        <p>Details:</p>
        <ul class="content">
          <li>8.5" x 5" Flat with Space for Sample Chip</li>
          <li>4/4 Color on #100 Gloss Cover</li>
        </ul>
        <p>
          <a href="https://tekstur.com/print/tekstur-chip-postcard.zip" class="button" download>Download Print Assets</a>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
// import Color from '@/components/Color.vue'
export default {
  components: {
    // Color
  },
  data () {
    return {
      pageTitle: 'Print Assets'
    }
  }
}
</script>
